module.exports = __webpack_public_path__ + "static/media/tvbet-roullette.7cf38af5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/games/tvbet-roullette.png
// module id = 2408
// module chunks = 7